/**
 * Generates school attendance data for a child for January and February 2024
 * @returns {Object} An object containing attendance data
 */
function generateAttendanceData() {
    // Define school days (excluding weekends and typical holidays)
    const schoolDays = {
        january: [
            { date: '2024-01-02', day: 'Tuesday' },    // Skip Jan 1 (New Year's Day)
            { date: '2024-01-03', day: 'Wednesday' },
            { date: '2024-01-04', day: 'Thursday' },
            { date: '2024-01-05', day: 'Friday' },
            { date: '2024-01-08', day: 'Monday' },
            { date: '2024-01-09', day: 'Tuesday' },
            { date: '2024-01-10', day: 'Wednesday' },
            { date: '2024-01-11', day: 'Thursday' },
            { date: '2024-01-12', day: 'Friday' },
            { date: '2024-01-15', day: 'Monday' },    // Skip for MLK Day
            { date: '2024-01-16', day: 'Tuesday' },
            { date: '2024-01-17', day: 'Wednesday' },
            { date: '2024-01-18', day: 'Thursday' },
            { date: '2024-01-19', day: 'Friday' },
            { date: '2024-01-22', day: 'Monday' },
            { date: '2024-01-23', day: 'Tuesday' },
            { date: '2024-01-24', day: 'Wednesday' },
            { date: '2024-01-25', day: 'Thursday' },
            { date: '2024-01-26', day: 'Friday' },
            { date: '2024-01-29', day: 'Monday' },
            { date: '2024-01-30', day: 'Tuesday' },
            { date: '2024-01-31', day: 'Wednesday' }
        ],
        february: [
            { date: '2024-02-01', day: 'Thursday' },
            { date: '2024-02-02', day: 'Friday' },
            { date: '2024-02-05', day: 'Monday' },
            { date: '2024-02-06', day: 'Tuesday' },
            { date: '2024-02-07', day: 'Wednesday' },
            { date: '2024-02-08', day: 'Thursday' },
            { date: '2024-02-09', day: 'Friday' },
            { date: '2024-02-12', day: 'Monday' },
            { date: '2024-02-13', day: 'Tuesday' },
            { date: '2024-02-14', day: 'Wednesday' },
            { date: '2024-02-15', day: 'Thursday' },
            { date: '2024-02-16', day: 'Friday' },
            { date: '2024-02-19', day: 'Monday' },    // Skip for Presidents' Day
            { date: '2024-02-20', day: 'Tuesday' },
            { date: '2024-02-21', day: 'Wednesday' },
            { date: '2024-02-22', day: 'Thursday' },
            { date: '2024-02-23', day: 'Friday' },
            { date: '2024-02-26', day: 'Monday' },
            { date: '2024-02-27', day: 'Tuesday' },
            { date: '2024-02-28', day: 'Wednesday' },
            { date: '2024-02-29', day: 'Thursday' }   // Leap year!
        ]
    };

    // Define attendance statuses as requested
    const statuses = ['Full day', 'Half day', 'One Lesson', 'Sick Leave'];

    // Generate attendance data for each day
    const attendanceData = {
        studentName: "Alex Johnson",
        grade: "3rd Grade",
        teacher: "Ms. Thompson",
        attendanceByMonth: {}
    };

    // Process each month
    ['january', 'february'].forEach(month => {
        attendanceData.attendanceByMonth[month] = [];

        schoolDays[month].forEach(dayInfo => {
            // Generate attendance pattern with new statuses
            // 70% Full day, 15% Half day, 10% One Lesson, 5% Sick Leave
            const rand = Math.random() * 100;
            let status = 'Full day';
            let arrivalTime = '8:00 AM';
            let departureTime = '3:00 PM';

            if (rand > 95) {
                status = 'Sick Leave';
                arrivalTime = null;
                departureTime = null;
            } else if (rand > 85) {
                status = 'One Lesson';
                // Randomly select morning or afternoon lesson
                if (Math.random() > 0.5) {
                    arrivalTime = '8:00 AM';
                    departureTime = '9:00 AM';
                } else {
                    arrivalTime = '2:00 PM';
                    departureTime = '3:00 PM';
                }
            } else if (rand > 70) {
                status = 'Half day';
                // Randomly select morning or afternoon
                if (Math.random() > 0.5) {
                    arrivalTime = '8:00 AM';
                    departureTime = '11:30 AM';
                } else {
                    arrivalTime = '11:30 AM';
                    departureTime = '3:00 PM';
                }
            }

            attendanceData.attendanceByMonth[month].push({
                date: dayInfo.date,
                dayOfWeek: dayInfo.day,
                status: status,
                arrivalTime: arrivalTime,
                departureTime: departureTime
            });
        });
    });

    // No summary statistics as requested

    return attendanceData;
}

// Generate and output the data
export const attendanceDetails = generateAttendanceData();

export const attendanceDataObject = {
    "studentName": "Alex Johnson",
    "grade": "3rd Grade",
    "teacher": "Ms. Thompson",
    "attendanceByMonth": {
        "january": [
            {
                "date": "2024-01-02",
                "dayOfWeek": "Tuesday",
                "status": "One Lesson",
                "arrivalTime": "8:00 AM",
                "departureTime": "9:00 AM"
            },
            {
                "date": "2024-01-03",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-04",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-05",
                "dayOfWeek": "Friday",
                "status": "Half day",
                "arrivalTime": "11:30 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-08",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-09",
                "dayOfWeek": "Tuesday",
                "status": "Half day",
                "arrivalTime": "8:00 AM",
                "departureTime": "11:30 AM"
            },
            {
                "date": "2024-01-10",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-11",
                "dayOfWeek": "Thursday",
                "status": "Half day",
                "arrivalTime": "8:00 AM",
                "departureTime": "11:30 AM"
            },
            {
                "date": "2024-01-12",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-15",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-16",
                "dayOfWeek": "Tuesday",
                "status": "One Lesson",
                "arrivalTime": "8:00 AM",
                "departureTime": "9:00 AM"
            },
            {
                "date": "2024-01-17",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-18",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-19",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-22",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-23",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-24",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-25",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-26",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-29",
                "dayOfWeek": "Monday",
                "status": "One Lesson",
                "arrivalTime": "2:00 PM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-30",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-01-31",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            }
        ],
        "february": [
            {
                "date": "2024-02-01",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-02",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-05",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-06",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-07",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-08",
                "dayOfWeek": "Thursday",
                "status": "Half day",
                "arrivalTime": "11:30 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-09",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-12",
                "dayOfWeek": "Monday",
                "status": "Half day",
                "arrivalTime": "8:00 AM",
                "departureTime": "11:30 AM"
            },
            {
                "date": "2024-02-13",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-14",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-15",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-16",
                "dayOfWeek": "Friday",
                "status": "Sick Leave",
                "arrivalTime": null,
                "departureTime": null
            },
            {
                "date": "2024-02-19",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-20",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-21",
                "dayOfWeek": "Wednesday",
                "status": "Half day",
                "arrivalTime": "11:30 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-22",
                "dayOfWeek": "Thursday",
                "status": "Half day",
                "arrivalTime": "8:00 AM",
                "departureTime": "11:30 AM"
            },
            {
                "date": "2024-02-23",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-26",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-27",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-28",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-02-29",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            }
        ],
        "march": [
            {
                "date": "2024-03-01",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-04",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-05",
                "dayOfWeek": "Tuesday",
                "status": "Half day",
                "arrivalTime": "8:00 AM",
                "departureTime": "11:30 AM"
            },
            {
                "date": "2024-03-06",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-07",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-08",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-11",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-12",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-13",
                "dayOfWeek": "Wednesday",
                "status": "One Lesson",
                "arrivalTime": "8:00 AM",
                "departureTime": "9:00 AM"
            },
            {
                "date": "2024-03-14",
                "dayOfWeek": "Thursday",
                "status": "Half day",
                "arrivalTime": "11:30 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-15",
                "dayOfWeek": "Friday",
                "status": "Sick Leave",
                "arrivalTime": null,
                "departureTime": null
            },
            {
                "date": "2024-03-18",
                "dayOfWeek": "Monday",
                "status": "Sick Leave",
                "arrivalTime": null,
                "departureTime": null
            },
            {
                "date": "2024-03-19",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-20",
                "dayOfWeek": "Wednesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-21",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-22",
                "dayOfWeek": "Friday",
                "status": "Half day",
                "arrivalTime": "8:00 AM",
                "departureTime": "11:30 AM"
            },
            {
                "date": "2024-03-25",
                "dayOfWeek": "Monday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-26",
                "dayOfWeek": "Tuesday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-27",
                "dayOfWeek": "Wednesday",
                "status": "One Lesson",
                "arrivalTime": "2:00 PM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-28",
                "dayOfWeek": "Thursday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            },
            {
                "date": "2024-03-29",
                "dayOfWeek": "Friday",
                "status": "Full day",
                "arrivalTime": "8:00 AM",
                "departureTime": "3:00 PM"
            }
        ]
    }
}